<template>
 <div >
        <div class="nav_link">
            <el-link type="primary"><router-link to="/books_rela">资源关联</router-link></el-link>
            <el-link type="primary"><router-link to="/">教辅资源编辑</router-link></el-link>
        </div>
        <div class="nav_bar">
            <div class="title">小睿已入库的书单</div>
            <div class="btn">
                <el-button @click="dialogFormVisible=true">注册书项目</el-button>
            </div>
        </div>
        <el-table
            ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="25">
            </el-table-column>            
            <el-table-column
                type="index"
                label="序号"
                width="50">
            </el-table-column>
            <el-table-column
                prop="bookName"
                label="书名"
                width="250">
            </el-table-column>
            <el-table-column
                prop="bookid"
                label="bookid"
                width="80"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="gradeName"
                label="年级"
                width="80"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="schoolYearName"
                label="学期"
                width="80"
                show-overflow-tooltip>
            </el-table-column>     
            <el-table-column
                prop="subjectName"
                label="科目"
                width="80"
                show-overflow-tooltip>
            </el-table-column>   
            <el-table-column
                prop="textbookVersionName"
                label="版本"
                width="80"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="questionsNum"
                label="题量"
                width="80"
                show-overflow-tooltip>
            </el-table-column>
             <el-table-column
                prop="bindedBookid"
                label="绑定"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="danger"
                    @click="resync_questions(scope.row)">刷新</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleBindAnwu(scope.row)">关联</el-button>
            </template>
            </el-table-column>           
        </el-table>
       

        <el-dialog title="注册书项目" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="小睿书ids" :label-width="formLabelWidth">
                        <el-input v-model="form.xrBookIds" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="pull_new_book">新 增</el-button>
                </div>
        </el-dialog>


        <el-dialog title="与暗物资源的绑定" :visible.sync="dialogFormBindVisible">
                <el-form :model="form">
                        <el-select v-model="awBookSelected"
                                    @change="on_anwubook_select_change"       
                                    placeholder="请选择"
                                    style="width:395px">
                            <el-option v-for="item in anwBooks"
                                        :key="item.bookid"
                                        :label="item.bookNameShow"
                                        :value="item.bookid"
                            >
                                    <span style="float: left">{{ item.bookNameShow }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 8px">{{ item.bookid }}</span>
                            </el-option>
                        </el-select>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormBindVisible = false">取 消</el-button>
                    <el-button type="primary" @click="relate_book_to_anwu_item">绑 定</el-button>
                </div>
        </el-dialog>

  </div>

</template>

<script>

import {sync_books_list,sync_newbooks,sync_book_question_detail,load_anwu_books} from '@/api/xrsync';
import {MessageBox,Message } from 'element-ui';
import {new_relate_book} from '@/api/edas';



  export default {
    data() {
      return {
        tableData: [],
        multipleSelection: [],
        anwBooks : [],
        form : {xrBookIds : ''},
        formLabelWidth: '80px',
        dialogTableVisible: false,
        dialogFormVisible: false,
        dialogFormBindVisible : false,
        awBookSelected : {},
        xrBookSelected : {}
      }
    },

    mounted : function() {
        this.load_sync_books();
    },

    methods: {

        goBack() {
            console.log('go back');
        },

        load_sync_books:function(){
            //加载已经从小睿的书列表
            sync_books_list().then(resp =>{
                console.log(resp);
                this.tableData = resp.data;
            });
        },

        resync_questions : function(item){
            //同步题目
            const _loading = this.$loading({
                lock: true,
                text: '系统处理中,请等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const bookid = item.bookid +"";
            console.log("resync_questions",bookid);
            sync_book_question_detail(bookid).then(res=>{
                _loading.close();
                Message({
                    message: '操作成功' || res.resultMsg,
                    type: 'tip',
                    duration: 5 * 1000
                });
                this.load_sync_books();
            });
        },


        pull_new_book : function(){
            //同步新的书籍数据
            if(this.form.xrBookIds && this.form.xrBookIds.length > 0){
                sync_newbooks(this.form.xrBookIds).then(res=>{
                    Message({
                        message: '操作成功' || res.resultMsg,
                        type: 'tip',
                        duration: 5 * 1000
                    });
                    this.load_sync_books();
                });
            }else{
                Message({
                    message: '请输入合法的内容',
                    type: 'warning',
                    duration: 5 * 1000
                });
            }

        },

        handleBindAnwu:function(currentXrBookItem){
            //把当前的书与 暗物识别结果进行关联
            console.log("handleBindAnwu",currentXrBookItem);
            this.xrBookSelected = currentXrBookItem;
            this.reload_anwu_books()
        },


        toggleSelection(rows) {
            if (rows) {
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
            } else {
            this.$refs.multipleTable.clearSelection();
            }
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        reload_anwu_books : function(e){
            //加载可以绑定的书籍信息
            load_anwu_books().then(resp =>{
                if(resp.code =='001'){
                    this.anwBooks = resp.data;
                    this.anwBooks.forEach(_bookitem =>{
                        _bookitem.bookNameShow = "《"+_bookitem.bookName +'》-'+ _bookitem.grade+'年级'+(_bookitem.term==2?"下 ":"上 ")+ _bookitem.bookVersion;
                    });
                    this.dialogFormBindVisible = true;
                }
            });
        },

        relate_book_to_anwu_item : function(){
            //把当前选择好的关联到暗物的项目上
            console.log('relate_book_to_anwu_item awBookSelected ' , this.awBookSelected);
            console.log('relate_book_to_anwu_item xrBookSelected ',this.xrBookSelected);

            let _awBookSelectedName = "";
            this.anwBooks.forEach(_bookitem =>{
                console.log('on_anwubook_select_change _bookitem ', JSON.stringify(_bookitem));
                if(_bookitem.bookid == this.awBookSelected){
                   _awBookSelectedName = _bookitem.bookName;
                }
            });


            this.$confirm('此操作将创建或更新关联关系, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const anBookId = this.awBookSelected;
                    const anBookName = _awBookSelectedName;
                    const xrBookId = this.xrBookSelected.bookid;
                    const xrBookName = this.xrBookSelected.bookName;
                    new_relate_book(anBookId,anBookName,xrBookId,xrBookName).then(resp =>{
                        if (resp.code =='001'){
                            Message({
                                    message: '操作成功' || resp.resultMsg,
                                    type: 'tip',
                                    duration: 5 * 1000
                            });
                            this.dialogFormBindVisible = false;
                            this.load_sync_books();
                        }
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


        },

        on_anwubook_select_change : function(selectedAnBookId){
            console.log('on_anwubook_select_change selectedAnBookId',selectedAnBookId);
            console.log('on_anwubook_select_change books' , this.anwBooks)
            console.log('on_anwubook_select_change ', JSON.stringify(this.awBookSelected))
        }

    }
  }
</script>




<style lang="less">
    .nav_link{
        margin-right : 20px;
        font-size: 20px;
        margin: 10px;
    }
    .nav_bar{
        font-size: 18px;
        margin: 10px;
        .title{
            margin-left: auto;
        }
        .btn{
            font-size: 1px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/xrbs/books.vue